// extracted by mini-css-extract-plugin
module.exports = {"root":"products_root__3A3EF","title":"products_title__2v5Oq"};